import React from 'react';
import { CheckCircle, Edit3, Loader2, XCircle } from 'lucide-react';
import Modal from '../../components/Modal';

export default function RequestDetailModals({
  actionLoading,
  handleDelete,
  handleReview,
  reviewAction,
  reviewLane,
  reviewNotes,
  setReviewAction,
  setReviewLane,
  setReviewNotes,
  setShowDeleteModal,
  setShowReviewModal,
  showDeleteModal,
  showReviewModal,
}) {
  return (
    <>
      {/* Review Modal */}
      <Modal
        isOpen={showReviewModal}
        onClose={() => {
          setShowReviewModal(false);
          setReviewLane('');
        }}
        title={`${reviewLane === 'security' ? 'Security' : 'Legal'} review`}
        size="sm"
        footer={(
          <>
            <button onClick={() => setShowReviewModal(false)} className="btn outline sm">
              Cancel
            </button>
            <button
              onClick={handleReview}
              disabled={!reviewAction || !reviewLane || actionLoading}
              className="btn primary sm"
            >
              {actionLoading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null}
              {actionLoading ? 'Submitting…' : 'Submit review'}
            </button>
          </>
        )}
      >
        <div className="card-body" style={{ paddingTop: 4 }}>
          <div style={{ marginBottom: 16 }}>
            <label className="field-label">Action</label>
            <div className="stack-sm">
              {[
                { value: 'approve', label: 'Approve', Icon: CheckCircle, color: 'var(--color-green-500)' },
                { value: 'reject', label: 'Reject', Icon: XCircle, color: 'var(--color-red-500)' },
                { value: 'request_changes', label: 'Request changes', Icon: Edit3, color: 'var(--color-yellow-500)' },
              ].map(({ value, label, Icon, color }) => (
                <label
                  key={value}
                  className="row"
                  style={{
                    gap: 10,
                    padding: '10px 12px',
                    border: '0.5px solid var(--border-primary)',
                    borderRadius: 8,
                    cursor: 'pointer',
                    background: reviewAction === value ? 'var(--surface-hover)' : 'transparent',
                  }}
                >
                  <input
                    type="radio"
                    name="reviewAction"
                    value={value}
                    checked={reviewAction === value}
                    onChange={(e) => setReviewAction(e.target.value)}
                  />
                  <Icon className="w-4 h-4" style={{ color }} />
                  <span style={{ fontSize: 13, fontWeight: 450, color: 'var(--text-primary)' }}>{label}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="field-label">Notes (optional)</label>
            <textarea
              value={reviewNotes}
              onChange={(e) => setReviewNotes(e.target.value)}
              rows={3}
              placeholder="Add any notes for the requester…"
              className="textarea"
            />
          </div>
        </div>
      </Modal>

      {/* Delete Modal */}
      <Modal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Delete request"
        size="sm"
        footer={(
          <>
            <button onClick={() => setShowDeleteModal(false)} className="btn outline sm">
              Cancel
            </button>
            <button onClick={handleDelete} disabled={actionLoading} className="btn danger sm">
              {actionLoading ? 'Deleting…' : 'Delete request'}
            </button>
          </>
        )}
      >
        <div className="card-body">
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
            Permanently delete this request, along with its uploaded documents and
            status history? This cannot be undone. To hide it without deleting,
            use Archive instead.
          </div>
        </div>
      </Modal>
    </>
  );
}
